function _typeof(obj) {
    '@babel/helpers - typeof';
    return _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
    }, _typeof(obj);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError('Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o)
        return;
    if (typeof o === 'string')
        return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === 'Object' && o.constructor)
        n = o.constructor.name;
    if (n === 'Map' || n === 'Set')
        return Array.from(o);
    if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null || iter['@@iterator'] != null)
        return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr))
        return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length)
        len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++)
        arr2[i] = arr[i];
    return arr2;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, 'prototype', { writable: false });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, 'string');
    return _typeof(key) === 'symbol' ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== 'object' || input === null)
        return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || 'default');
        if (_typeof(res) !== 'object')
            return res;
        throw new TypeError('@@toPrimitive must return a primitive value.');
    }
    return (hint === 'string' ? String : Number)(input);
}
import utils from '../utils.js';
export var Slider = function () {
    function Slider(_ref) {
        var _this = this;
        var el = _ref.el, min = _ref.min, max = _ref.max, step = _ref.step, _ref$value = _ref.value, value = _ref$value === void 0 ? 0 : _ref$value, onChange = _ref.onChange, onDragStart = _ref.onDragStart, onDragEnd = _ref.onDragEnd, onDrag = _ref.onDrag;
        _classCallCheck(this, Slider);
        this.el = el;
        this.min = Number(min);
        this.max = Number(max);
        this.step = Number(step);
        this.value = Number(value) == NaN ? value : Number(value);
        this.onChange = onChange;
        this.onDragStart = onDragStart;
        this.onDragEnd = onDragEnd;
        this.onDrag = onDrag;
        this.track = this.el.querySelector('.slider-track');
        this.bar = this.track.querySelector('.slider-bar');
        this.thumbTrack = this.track.querySelector('.slider-thumb-track');
        this.thumb = this.track.querySelector('.slider-thumb');
        this.el.addEventListener(utils.nameMap.dragStart, function (event) {
            var _this$onDragStart;
            var e = event || window.event;
            var trackLength = _this.track.offsetWidth;
            var nMax = _this.thumbTrack.offsetWidth;
            nMax = nMax ? nMax : trackLength;
            var thumbTrackX = (trackLength - nMax) / 2;
            var clientX = e.clientX || e.changedTouches[0].clientX;
            var nLeft = _this.el.getBoundingClientRect().left;
            var nLength = clientX - nLeft - thumbTrackX;
            nLength = nLength >= nMax ? nMax : nLength <= 0 ? 0 : nLength;
            var value = _this.step ? Math.round(nLength / nMax * (_this.max - _this.min) / _this.step) * _this.step + _this.min : nLength / nMax * (_this.max - _this.min) + _this.min;
            (_this$onDragStart = _this.onDragStart) === null || _this$onDragStart === void 0 ? void 0 : _this$onDragStart.call(_this, value);
            if (_this.value != value) {
                _this.drag(value);
            }
            var mousemoveEvent = function mousemoveEvent(event) {
                var e = event || window.event;
                e.preventDefault();
                e.stopPropagation();
                var clientX = e.clientX || e.changedTouches[0].clientX;
                var nLength = clientX - nLeft - thumbTrackX;
                nLength = nLength >= nMax ? nMax : nLength <= 0 ? 0 : nLength;
                var value = _this.step ? Math.round(nLength / nMax * (_this.max - _this.min) / _this.step) * _this.step + _this.min : nLength / nMax * (_this.max - _this.min) + _this.min;
                if (_this.value != value) {
                    _this.drag(value);
                }
                window.getSelection ? window.getSelection().removeAllRanges() : document.selection.empty();
            };
            var removeEvent = function removeEvent(event) {
                var _this$onDragEnd;
                var e = event || window.event;
                e.stopPropagation();
                window.getSelection ? window.getSelection().removeAllRanges() : document.selection.empty();
                document.removeEventListener(utils.nameMap.dragMove, mousemoveEvent);
                document.removeEventListener(utils.nameMap.dragEnd, removeEvent);
                (_this$onDragEnd = _this.onDragEnd) === null || _this$onDragEnd === void 0 ? void 0 : _this$onDragEnd.call(_this, value);
            };
            document.addEventListener(utils.nameMap.dragMove, mousemoveEvent);
            document.addEventListener(utils.nameMap.dragEnd, removeEvent);
        });
        setTimeout(function () {
            _this.setValue(_this.value);
        }, 0);
    }
    _createClass(Slider, [
        {
            key: 'setValue',
            value: function setValue(value) {
                var _this$onChange;
                this.value = value <= this.min ? this.min : value >= this.max ? this.max : value;
                var per = (this.value - (this.min + 2)) / (this.max - this.min - 4);
                this.thumb.style.left = per * 100 + '%';
                this.bar.style.width = Math.max(Math.min(per, 1), 0.01) * 100 + '%';
                (_this$onChange = this.onChange) === null || _this$onChange === void 0 ? void 0 : _this$onChange.call(this, this.value);
            }
        },
        {
            key: 'drag',
            value: function drag(value) {
                var _this$onDrag;
                this.setValue(value);
                (_this$onDrag = this.onDrag) === null || _this$onDrag === void 0 ? void 0 : _this$onDrag.call(this, this.value);
            }
        }
    ]);
    return Slider;
}();
export var SliderVertical = function () {
    function SliderVertical(_ref2) {
        var _this2 = this;
        var el = _ref2.el, min = _ref2.min, max = _ref2.max, step = _ref2.step, _ref2$value = _ref2.value, value = _ref2$value === void 0 ? 0 : _ref2$value, onChange = _ref2.onChange, onDragStart = _ref2.onDragStart, onDragEnd = _ref2.onDragEnd, onDrag = _ref2.onDrag;
        _classCallCheck(this, SliderVertical);
        this.el = el;
        this.min = Number(min);
        this.max = Number(max);
        this.step = Number(step);
        this.value = Number(value) == NaN ? value : Number(value);
        this.onChange = onChange;
        this.onDragStart = onDragStart;
        this.onDragEnd = onDragEnd;
        this.onDrag = onDrag;
        this.track = this.el.querySelector('.slider-track');
        this.bar = this.track.querySelector('.slider-bar');
        this.thumbTrack = this.track.querySelector('.slider-thumb-track');
        this.thumb = this.track.querySelector('.slider-thumb');
        this.el.addEventListener(utils.nameMap.dragStart, function (event) {
            var _this2$onDragStart;
            var e = event || window.event;
            var trackLength = _this2.track.offsetHeight;
            var nMax = _this2.thumbTrack.offsetHeight;
            nMax = nMax ? nMax : trackLength;
            var thumbTrackY = (trackLength - nMax) / 2;
            var clientY = e.clientY || e.changedTouches[0].clientY;
            var nTop = _this2.el.getBoundingClientRect().top;
            var nLength = nMax - (clientY - nTop - thumbTrackY);
            nLength = nLength >= nMax ? nMax : nLength <= 0 ? 0 : nLength;
            var value = _this2.step ? Math.round(nLength / nMax * (_this2.max - _this2.min) / _this2.step) * _this2.step + _this2.min : nLength / nMax * (_this2.max - _this2.min) + _this2.min;
            var per = (value - (_this2.min + 6)) / (_this2.max - _this2.min - 12);
            (_this2$onDragStart = _this2.onDragStart) === null || _this2$onDragStart === void 0 ? void 0 : _this2$onDragStart.call(_this2, value);
            if (_this2.value != value) {
                _this2.drag(value);
            }
            _this2.thumb.style.top = (1 - per) * 100 + '%';
            _this2.bar.style.height = Math.max(Math.min(per, 1), 0) * 100 + '%';
            var mousemoveEvent = function mousemoveEvent(event) {
                var e = event || window.event;
                e.preventDefault();
                window.getSelection ? window.getSelection().removeAllRanges() : document.selection.empty();
                var clientY = e.clientY || e.changedTouches[0].clientY;
                var nLength = nMax - (clientY - nTop - thumbTrackY);
                nLength = nLength >= nMax ? nMax : nLength <= 0 ? 0 : nLength;
                var value = _this2.step ? Math.round(nLength / nMax * (_this2.max - _this2.min) / _this2.step) * _this2.step + _this2.min : nLength / nMax * (_this2.max - _this2.min) + _this2.min;
                if (_this2.value != value) {
                    _this2.drag(value);
                }
            };
            var removeEvent = function removeEvent(event) {
                var _this2$onDragEnd;
                var e = event || window.event;
                e.preventDefault();
                document.removeEventListener(utils.nameMap.dragMove, mousemoveEvent);
                document.removeEventListener(utils.nameMap.dragEnd, removeEvent);
                (_this2$onDragEnd = _this2.onDragEnd) === null || _this2$onDragEnd === void 0 ? void 0 : _this2$onDragEnd.call(_this2, value);
            };
            document.addEventListener(utils.nameMap.dragMove, mousemoveEvent);
            document.addEventListener(utils.nameMap.dragEnd, removeEvent);
        });
        setTimeout(function () {
            _this2.setValue(_this2.value);
        }, 0);
    }
    _createClass(SliderVertical, [
        {
            key: 'setValue',
            value: function setValue(value) {
                var _this$onChange2;
                this.value = Math.max(Math.min(value, this.max), this.min);
                var per = (this.value - (this.min + 6)) / (this.max - this.min - 12);
                this.thumb.style.top = (1 - per) * 100 + '%';
                this.bar.style.height = Math.max(Math.min(per, 1), 0) * 100 + '%';
                (_this$onChange2 = this.onChange) === null || _this$onChange2 === void 0 ? void 0 : _this$onChange2.call(this, value);
            }
        },
        {
            key: 'drag',
            value: function drag(value) {
                var _this$onDrag2;
                this.setValue(value);
                (_this$onDrag2 = this.onDrag) === null || _this$onDrag2 === void 0 ? void 0 : _this$onDrag2.call(this, this.value);
            }
        }
    ]);
    return SliderVertical;
}();
export var Picker = function () {
    function Picker(_ref3) {
        var _this3 = this;
        var el = _ref3.el, _ref3$value = _ref3.value, value = _ref3$value === void 0 ? null : _ref3$value, onChange = _ref3.onChange, onPick = _ref3.onPick;
        _classCallCheck(this, Picker);
        this.el = el;
        this.items = el.querySelectorAll('.picker-item');
        this.value = value;
        this.onChange = onChange;
        this.onPick = onPick;
        this.valueList = [];
        this.items.forEach(function (item) {
            _this3.valueList.push(item.getAttribute('data-value'));
            item.addEventListener('click', function () {
                _this3.pick(item.getAttribute('data-value'), true);
            });
        });
        setTimeout(function () {
            _this3.setValue(_this3.value, false);
        }, 0);
    }
    _createClass(Picker, [
        {
            key: 'setValue',
            value: function setValue(value) {
                var _this$onChange3;
                this.items.forEach(function (n, i) {
                    if (n.getAttribute('data-value') == value) {
                        n.classList.add('picked');
                    } else {
                        n.classList.remove('picked');
                    }
                });
                this.value = value;
                (_this$onChange3 = this.onChange) === null || _this$onChange3 === void 0 ? void 0 : _this$onChange3.call(this, value);
            }
        },
        {
            key: 'pick',
            value: function pick(value) {
                var _this$onPick;
                this.setValue(value);
                (_this$onPick = this.onPick) === null || _this$onPick === void 0 ? void 0 : _this$onPick.call(this, value);
            }
        }
    ]);
    return Picker;
}();
export var MultiPicker = function () {
    function MultiPicker(_ref4) {
        var _this4 = this;
        var el = _ref4.el, _ref4$value = _ref4.value, value = _ref4$value === void 0 ? [] : _ref4$value, onChange = _ref4.onChange, onItemChange = _ref4.onItemChange, onPick = _ref4.onPick;
        _classCallCheck(this, MultiPicker);
        this.el = el;
        this.items = el.querySelectorAll('.picker-item');
        this.valueSet = new Set(value);
        this.onChange = onChange;
        this.onItemChange = onItemChange;
        this.onPick = onPick;
        this.valueList = [];
        this.domMap = new Map();
        this.items.forEach(function (item) {
            _this4.valueList.push(item.getAttribute('data-value'));
            _this4.domMap.set(item.getAttribute('data-value'), item);
            item.addEventListener('click', function () {
                var val = item.getAttribute('data-value');
                if (_this4.valueSet.has(val)) {
                    _this4.unpick(val);
                } else {
                    _this4.pick(val);
                }
            });
        });
        setTimeout(function () {
            _this4.setValue(_this4.value, false);
        }, 0);
    }
    _createClass(MultiPicker, [
        {
            key: 'value',
            get: function get() {
                return _toConsumableArray(this.valueSet);
            }
        },
        {
            key: 'pick',
            value: function pick(val) {
                var _this$onChange4, _this$onPick2;
                this.domMap.get(val).classList.add('picked');
                this.valueSet.add(val);
                (_this$onChange4 = this.onChange) === null || _this$onChange4 === void 0 ? void 0 : _this$onChange4.call(this, this.value);
                (_this$onPick2 = this.onPick) === null || _this$onPick2 === void 0 ? void 0 : _this$onPick2.call(this, val, true);
            }
        },
        {
            key: 'unpick',
            value: function unpick(val) {
                var _this$onChange5, _this$onPick3;
                this.domMap.get(val).classList.remove('picked');
                this.valueSet['delete'](val);
                (_this$onChange5 = this.onChange) === null || _this$onChange5 === void 0 ? void 0 : _this$onChange5.call(this, this.value);
                (_this$onPick3 = this.onPick) === null || _this$onPick3 === void 0 ? void 0 : _this$onPick3.call(this, val, false);
            }
        },
        {
            key: 'setValue',
            value: function setValue(value) {
                var _this5 = this;
                this.valueSet = new Set(value);
                this.valueList.forEach(function (n) {
                    if (_this5.valueSet.has(n)) {
                        var _this5$pick;
                        _this5.domMap.get(n).classList.add('picked');
                        (_this5$pick = _this5.pick) === null || _this5$pick === void 0 ? void 0 : _this5$pick.call(_this5, n);
                    } else {
                        var _this5$unpick;
                        _this5.domMap.get(n).classList.remove('picked');
                        (_this5$unpick = _this5.unpick) === null || _this5$unpick === void 0 ? void 0 : _this5$unpick.call(_this5, n);
                    }
                });
            }
        }
    ]);
    return MultiPicker;
}();
export var Switch = function () {
    function Switch(_ref5) {
        var _this6 = this;
        var el = _ref5.el, _ref5$value = _ref5.value, value = _ref5$value === void 0 ? false : _ref5$value, onChange = _ref5.onChange, onToggle = _ref5.onToggle;
        _classCallCheck(this, Switch);
        this.el = el;
        this.value = value;
        this.onChange = onChange;
        this.onToggle = onToggle;
        this.el.addEventListener('click', function () {
            _this6.toggle(!_this6.value);
        });
        setTimeout(function () {
            _this6.setValue(_this6.value);
        }, 0);
    }
    _createClass(Switch, [
        {
            key: 'setValue',
            value: function setValue(value) {
                var _this$onChange6;
                this.value = value;
                this.el.classList.toggle('switch-on', value);
                (_this$onChange6 = this.onChange) === null || _this$onChange6 === void 0 ? void 0 : _this$onChange6.call(this, value);
            }
        },
        {
            key: 'toggle',
            value: function toggle(value) {
                var _this$onToggle;
                this.setValue(value);
                (_this$onToggle = this.onToggle) === null || _this$onToggle === void 0 ? void 0 : _this$onToggle.call(this, value);
            }
        }
    ]);
    return Switch;
}();